import { setCookie, getCookie } from './cookies';

const mktPrefixes = ['utm_', 'trk_', 'gad_', 'aff_trk_'];
const mktExactParams = [
	'gclid', 'fbclid', 'msclkid', 'msclid', 'gbraid', 'wbraid', 'ttclid', 'oppref',
	'campaign', '_fbp', '_fbc', 'ptcode', 'ad_id',
	'cid', 'aid', 'dt',
];

function isMarketingParam(key) {
	return mktPrefixes.some((prefix) => key.startsWith(prefix)) || mktExactParams.includes(key);
}

function getTrafficType(params) {
	if (Object.keys(params).length === 0) return 'organic';
	return 'paid';
}

function getHeapSessionId() {
	try {
		return window.heap?.sessionId ?? null;
	} catch (e) {
		return null;
	}
}

function ddLog(action, data) {
	if (typeof window.DD_RUM !== 'undefined') {
		window.DD_RUM.addAction(action, data);
	}
}

export function setPaidMarketingSessionCookie() {
	const urlParams = new URLSearchParams(window.location.search);

	// Collect marketing params from URL in DynamoDB-style format
	const marketingParams = {};
	urlParams.forEach((value, key) => {
		if (isMarketingParam(key)) {
			marketingParams[key] = { S: value };
		}
	});

	const trafficType = Object.keys(marketingParams).length > 0 ? 'paid' : 'organic';

	// Read existing cookie for comparison
	let existingCookie = null;
	try {
		const raw = getCookie('bark_mkt_session');
		if (raw) existingCookie = JSON.parse(raw);
	} catch (e) {
		// Corrupted cookie
	}

	// Skip bark_mkt_session_compare only when organic on SLF seller profile (no marketing params in URL)
	const skipCompare =
		trafficType === 'organic' && window?.Bark?.ENV?.site_page_type === 'SLF Company Page';
	if (!skipCompare) {
		ddLog('bark_mkt_session_compare', {
			heap_session_id: getHeapSessionId(),
			traffic_type: trafficType,
			url_params: marketingParams,
			existing_cookie: existingCookie,
			url: window.location.href,
		});
	}

	// If marketing params in URL → overwrite cookie with full new payload + 24h expiry
	if (trafficType === 'paid') {
		const now = new Date().toISOString();
		const cookiePayload = {
			marketingParams: marketingParams,
			lastUpdatedAt: now,
			firstTouchAt: existingCookie?.firstTouchAt ?? now,
		};

		setCookie({ name: 'bark_mkt_session', value: JSON.stringify(cookiePayload), expiryDays: 1, overwrite: true });

		// DD log: cookie written/updated
		ddLog('bark_mkt_session_updated', {
			heap_session_id: getHeapSessionId(),
			traffic_type: trafficType,
			cookie_values: cookiePayload,
		});

		return;
	}
}

export function setInitialReferrerCookie() {
	const name = 'trk_initial_referrer';
	const value = document.referrer ?? 'direct';

	setCookie({ name, value });
}

export function setBarkLandingPageCookie() {
	const name = 'trk_bark_landing_page';
	const value = window.location.href;

	setCookie({ name, value });
}
